var _defs, _circle, _path, _path2, _path3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSurprise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcd844;}.cls-2{fill:#363636;}.cls-3{fill:#ff5961;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-surprise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 350
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.38,476.81a59.28,59.28,0,1,1,59.28-59.28A59.35,59.35,0,0,1,353.38,476.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M646.62,476.81a59.28,59.28,0,1,1,59.29-59.28A59.35,59.35,0,0,1,646.62,476.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500,745.88c-29.71,0-57.31-13.63-77.72-38.37-19.12-23.18-29.65-53.68-29.65-85.87s10.53-62.69,29.65-85.88c20.41-24.74,48-38.36,77.72-38.36h0c29.71,0,57.31,13.62,77.72,38.36,19.12,23.19,29.65,53.68,29.65,85.88s-10.53,62.69-29.65,85.87C557.31,732.25,529.71,745.88,500,745.88Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 500,
    cy: 660.76,
    rx: 57.13,
    ry: 50.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurprise);
export default __webpack_public_path__ + "static/media/icon-surprise.431501113e33e8a8a57e73945aead864.svg";
export { ForwardRef as ReactComponent };